module.exports = __webpack_public_path__ + "static/media/accounts.6c767a77.svg";